import { render, staticRenderFns } from "./DetalhesCotacaoHistoricoTab.vue?vue&type=template&id=205e47e6&scoped=true"
import script from "./DetalhesCotacaoHistoricoTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesCotacaoHistoricoTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetalhesCotacaoHistoricoTab.vue?vue&type=style&index=0&id=205e47e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e47e6",
  null
  
)

export default component.exports